export default __webpack_public_path__ + "images/drinkup-logo2.png";